import { useLocation } from 'react-router';

import { hasTrufflsOrigin } from '@/helpers/truffls-origin';
import { useLoginStates } from '@/hooks';

export function useIsLoggedOutProfileCreationEnabled(): boolean {
  const { search } = useLocation();
  const { isLoggedIn } = useLoginStates();

  return !isLoggedIn && !hasTrufflsOrigin(search);
}
